/**
 * Centralized translations for Business Units Screen module
 * Contains all labels used across business units screen components
 */

export const BusinessUnitsScreenLabels = {
    it: {
        // Navigation and breadcrumb
        home: 'Home',
        admin: 'Admin',
        organizationalChart: 'Organigramma',
        
        // Main operations
        saving: 'Salvataggio in corso',
        savingNewData: 'Salvataggio dei dati in corso',
        saveThisData: 'Salva questi dati',
        switchToTreeView: 'Passa alla vista ad albero',
        switchToListView: 'Passa alla vista a lista',
        
        // Success/Error messages
        error: 'OOOPS!!',
        success: 'Tutto OK',
        nothingToSave: 'Nessun dato da salvare',
        nothingToSaveMessage: `Non ci sono aggiornamenti dall'ultimo salvataggio`,
        savedSussessfullyWithNumberMessage: `{{number}} business units salvate con successo`,
        
        // Validation messages
        missingNameForBU: `Non e' stato inserito il nome per la business unit numero #{{index}}`,
        missingTypeForBU: `Non e' stato inserito il tipo per la business unit {{name}}`,
        
        // General
        loading: 'Caricamento...',
        name: 'Nome',
        type: 'Tipo',
        code: 'Codice'
    },
    
    en: {
        // Navigation and breadcrumb
        home: 'Home',
        admin: 'Admin', 
        organizationalChart: 'Organizational Chart',
        
        // Main operations
        saving: 'Saving',
        savingNewData: 'Saving new data',
        saveThisData: 'Save this data',
        switchToTreeView: 'Switch to Tree View',
        switchToListView: 'Switch to List View',
        
        // Success/Error messages
        error: 'OOOPS!!',
        success: 'Well Done',
        nothingToSave: 'Nothing to save',
        nothingToSaveMessage: `There are no updates since the last save`,
        savedSussessfullyWithNumberMessage: `{{number}} business units saved successfully`,
        
        // Validation messages
        missingNameForBU: `The name is missing for the business unit # {{index}}`,
        missingTypeForBU: `The type is missing for the business unit {{name}}`,
        
        // General
        loading: 'Loading...',
        name: 'Name',
        type: 'Type',
        code: 'Code'
    }
}; 